import http from '@/services/http';

const recipientGroups = {
  index(tableFilters) {
    const filter = {
      ...tableFilters,
      include: ['roles'],
    };
    return http.request({
      method: 'get',
      url: '/signature-groups',
      params: { filter },
    });
  },
  count() {
    return http.request({
      method: 'get',
      url: '/signature-groups/count',
    });
  },
  show(id) {
    return http.request({
      method: 'get',
      url: `/signature-groups/${id}`,
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/signature-groups',
      data,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/signature-groups/${id}`,
      data,
    });
  },
  deleteGroup(id) {
    return http.request({
      method: 'delete',
      url: `/signature-groups/${id}`,
    });
  },
};

export default recipientGroups;
